import { FileDown, RotateCw } from "lucide-react";
import { useParams } from "react-router-dom";

import { useDocument, useAsset } from "../../../hooks/query";
import { useNotification } from "../../../hooks/useNotification";
import { DocumentPreviewWidget } from "../../";
import { useInitialInspection } from "./hooks";

export function InitialInspectionReport() {
    const { id: projectId } = useParams();
    const { inspectionDocument, refreshInspection } = useInitialInspection();
    const { useInitialInspectionCreate } = useDocument();
    const { useDownload } = useAsset();
    const { showSuccess, showError } = useNotification();

    const initialInspectionReportGenerationSvc = useInitialInspectionCreate();
    const downloadAssetSvc = useDownload();

    const handleGenerateReport = async () => {
        if (!projectId) {
            showError("Project ID not found");
            return;
        }

        try {
            const data = await initialInspectionReportGenerationSvc.mutateAsync({ ProjectId: projectId });

            if (data?.assetId) {
                await downloadAssetSvc.mutateAsync({ AssetId: data.assetId });
                showSuccess("Initial Inspection report downloaded successfully");
            } else {
                showError("Failed to generate download link");
            }

            setTimeout(() => {
                refreshInspection();
            }, 1000);
        } catch (error) {
            console.error("Error generating report:", error);
            showError("Failed to generate report");
        }
    };

    return (
        <DocumentPreviewWidget
            thumbnailUrl={inspectionDocument?.thumbnailUrl}
            title="Initial Inspection Report"
            description="Generated summary of roof condition and inspection findings"
            status={inspectionDocument?.Status || "INIT"}
            assetId={inspectionDocument?.DocumentAssetId}
            buttonText="Download"
            buttonIcon={<FileDown size={16} />}
            onButtonClick={handleGenerateReport}
            loading={initialInspectionReportGenerationSvc.isPending || downloadAssetSvc.isPending}
            menuActions={
                inspectionDocument?.DocumentAssetId
                    ? [
                          {
                              label: "Regenerate",
                              icon: <RotateCw size={16} />,
                              onClick: handleGenerateReport,
                              disabled: initialInspectionReportGenerationSvc.isPending,
                          },
                      ]
                    : []
            }
        />
    );
}
